import { useQuery } from '@tanstack/react-query';
import { QueryConfig, ExtractFnReturnType } from '../../../../lib/react-query';
import i18n from '../../../../i18n';
import { getFunctionalAreaSelect } from '../api/functionalAreas';




type QueryFnType = typeof getFunctionalAreaSelect;

type UseServiceFunctionalAreaOptions = { 
  config?: QueryConfig<QueryFnType>;
};

export const useFunctionalAreaSelect = ({ config = {} }: UseServiceFunctionalAreaOptions) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['functionalAreasSelect', i18n.language],
        queryFn: () => getFunctionalAreaSelect(), //
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};